// extracted by mini-css-extract-plugin
export var avatarContainer = "_4u-1";
export var largeAvatarContainer = "_4u-2";
export var smallAvatarContainer = "_4u-0";